<template>
  <div class="lang-selector-container">
    <v-textarea 
      v-if="multiLine"
      :label="label"
      name="descrizione"
      :value="getDescrValue()"
      @input.native="updateDescr"
      :disabled="keepSync || false"
    >
    </v-textarea> 
    <v-text-field
      v-else
      :label="label"
      name="descrizione"
      :value="getDescrValue()"
      @input.native="updateDescr"
      :disabled="keepSync || false"
    ></v-text-field>
    <v-menu :disabled="keepSync || false" left>
      <a slot="activator" class="flag-icon" :class="[`flag-icon-${getFlag()}`, keepSync ? 'disabled' : '']"></a>
      <v-list>
        <v-list-tile @click.native="changeLang(flag)" v-for="flag in flags" :key="flag.name">
          <v-list-tile-title>{{flag.name}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
/**
 * Editor per la descrizione di un oggetto ( con selettore lingua )
 * @module components/common/DescrEditor
 */
  export default {
    name: 'descrEditor',
    data () {
      return {
        currentDescr: this.value
      }
    },
    methods: {
      getFlag () {
        return this.currentLang ? this.flags.find(flag => flag.value == this.currentLang).flag : ""
      },
      changeLang (flag) {
        this.$emit('changeLang', flag.value)
      },
      getDescrValue () {
        let descriptionValue = null;
        if (this.value) {
          descriptionValue =  this.value.find(descr => descr.lingua == this.currentLang).contenuto;
        } 
        return descriptionValue;
      },
      updateDescr (newValue) {
        this.currentDescr.find(descr => descr.lingua == this.currentLang).contenuto = newValue.target.value
        this.$emit('setDescr', this.currentDescr)
      }
    },
    computed: {
      multiLine () {
        return this.multi || false
      },
      label () {
        if(this.labelOverride) return this.labelOverride
        return this.multi ? 'Descrizione Estesa' : 'Descrizione'
      },
      flags () {
        return this.$store.getters.lingue.filter(lingua => this.$store.getters.User.settings.lingue.includes(lingua.value))
      }
    },
    watch: {
      currentLang (newV) {
        if(!this.currentDescr.find(descr => descr.lingua == this.currentLang))
          this.currentDescr.push({lingua: newV, main: false, contenuto: ''})
      }
    },
    /**
     * @prop value {array} - Insieme delle descrizioni
     * @prop currentLang {string} - L'identificatore della lingua corrent
     * @prop multi {boolean} - Indica se il campo è multiriga e cambia il titolo di conseguenza
     * @prop keepSync {boolean} - Se vero readonly
    */
    props: ['value', 'currentLang', 'multi', 'keepSync', 'labelOverride']
  }
</script>

<style lang="stylus">
  .flag-icon
    width: 30px
    height: 22px
    padding: 10px
    box-shadow: 2.5px 2.5px 3px 0.05px #333;
    &.disabled
      opacity: .5
  .lang-selector-container
    display: flex
</style>


// WEBPACK FOOTER //
// src/components/common/DescrEditor.vue